import React from "react";
import { SectionsUIProvider } from "./SectionsUIContext";
import { SectionsCard } from "./SectionsCard";

export function SectionsPage({
  noticeId
}) {
  return (
    <SectionsUIProvider noticeId={noticeId}>
      <SectionsCard />
    </SectionsUIProvider>
 );
}